import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../../_Shared/DataTables/DataToolbar';
import DataTable from '../../_Shared/DataTables/DataTable';
import CreateModal from '../../_Shared/CreateModal';
import AppContent from '../../_Shared/Layout/AppContent';

const _ = require('lodash');

class BrandList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            brandName: '',
            showModal: false,
            anchorEl: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { advertiser } = this.props;
        if (advertiser !== null && !_.isEqual(prevProps.advertiser, advertiser)) {
            this.setState({ advertiser });
        }
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    toggleCreateModal = e => {
        const { showModal } = this.state;
        this.setState({ showModal: !showModal, brandName: '', isUpdate: false });
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleEditModal = e => {
        const { brandName, showModal } = this.state;
        this.setState({ showModal: !showModal, anchorEl: null, brandName: brandName, isUpdate: true });
    }

    handleInputChange = brandName => this.setState({ brandName })

    selectElement = (brand, index) => {
        this.setState({ brandName: brand.name, selectedIndex: index });
    }

    createOrUpdateBrand = e => {
        const { advertiser, onAdvertiserUpdated } = this.props;
        const { brandName, isUpdate, selectedIndex } = this.state;
        if (!isUpdate) {
            onAdvertiserUpdated(Object.assign({}, advertiser, { brands: [...advertiser.brands, brandName] }), 'add_brand');
        } else {
            let aux = Object.assign([], advertiser.brands);
            aux.splice(selectedIndex, 1, brandName);            
            onAdvertiserUpdated(Object.assign({}, advertiser, { brands: aux }), 'update_brand');
        }
        this.toggleCreateModal(e);
        this.setState({ brandName: '' });
    }

    deleteBrand = () => {
        const { advertiser, onAdvertiserUpdated } = this.props;
        const { brandName } = this.state;
        onAdvertiserUpdated(Object.assign({}, advertiser, { brands: advertiser.brands.filter(x => x !== brandName) }), 'delete_brand');
        this.setState({ brandName: '', anchorEl: null });
    }

    render() {
        const { advertiser, loading } = this.props;
        const { showModal, brandName, anchorEl } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Brands" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                advertiser && advertiser.brands &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={advertiser.brands.map(x => ({ name: x }))}
                    toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={this.toggleEditModal}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteBrand}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create/Edit Brand" open={showModal} closeHandler={this.toggleCreateModal} saveHandler={this.createOrUpdateBrand}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        <TextField autoFocus value={brandName} onChange={e => this.handleInputChange(e.target.value)} id="brandName" name="brandName" label="Brand Name" type="text" fullWidth />
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

BrandList.propTypes = {
    advertiser: PropTypes.object.isRequired,
};

export default BrandList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Advertisers/Brands/BrandList.js